import React, { Component } from "react";

import LabMember from "../components/LabMember";

import nsfLogo from "../assets/images/team/NSF_4-Color_bitmap_Logo.png";
import zupancPhoto from "../assets/images/team/zupanc.jpg";
import trippPhoto from "../assets/images/team/tripp.jpg";
import lehotzkyPhoto from "../assets/images/team/lehotzky.jpg";
import chuPhoto from "../assets/images/team/chu.jpg";
import northeasternLogo from "../assets/images/team/NU_Monogram.png";

class LabMembersPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      members: [
        {
          name: "Günther K. H. Zupanc",
          position: "Principal Investigator",
          email: "g.zupanc@northeastern.edu",
          picture: zupancPhoto,
        },
        {
          name: "David Lehotzky",
          position: "Research Associate",
          email: "d.lehotzky@northeastern.edu",
          picture: lehotzkyPhoto,
        },
        {
          name: "Kyle M. Chu",
          position: "Website Developer",
          email: "chu.ky@northeastern.edu",
          picture: chuPhoto,
        },
        {
          name: "Isabel P. Tripp",
          position: "Website Developer",
          email: "tripp.i@northeastern.edu",
          picture: trippPhoto,
        },
        {
          name: "NSF",
          position:
            "Partial funding for the development of this website was provided by the National Science Foundation.",
          picture: nsfLogo,
          link: "https://nsf.gov/",
        },
        {
          name: "Northeastern University",
          position:
            "Support for the development of this website was provided by Information Technology Services and Research Computing of Northeastern University.",
          picture: northeasternLogo,
          link: "https://its.northeastern.edu/",
        },
      ],
    };
  }
  componentWillMount() {
    document.title = "People";
  }

  render() {
    return (
      <div className="container pt-4">
        <a name="skipnav" id="skipnav">
          <h1>Neurosphere Simulator Toolbox: Project Members</h1>
        </a>
        {this.state.members.map((member) => (
          <LabMember
            member={member}
            key={member.email}
            first={this.state.members.indexOf(member) === 0}
          />
        ))}
      </div>
    );
  }
}

export default LabMembersPage;
